import { createTheme } from '@mantine/core';
import { tokens } from '@ui-lib/css';

export const typeography = createTheme({
  fontFamily: '"Inq", sans-serif',
  fontSizes: {
    regular: tokens.typography.fontWeight.regular,
    demibold: tokens.typography.fontWeight.demibold,
  },

  headings: {
    fontWeight: '700',
    sizes: {
      h1: {
        fontSize: '40px',
        lineHeight: '52px',
      },
      h2: {
        fontSize: '36px',
        lineHeight: '44px',
      },
      h3: {
        fontSize: '32px',
        lineHeight: '40px',
      },
      h4: {
        fontSize: '28px',
        lineHeight: '36px',
      },
      h5: {
        fontSize: '24px',
        lineHeight: '32px',
      },
      h6: {
        fontSize: '20px',
        lineHeight: '28px',
      },
    },
  },
});
